(() => {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();

      this.variants = qsa(`#js-product-variants-${this.dataset.section}`);
      this.productForm = qs(`#main-product-form-${this.dataset.section}`);
      this.submitButton = qs('.js-main-product-add', this.productForm);
      this.stocks = qs(`#js-product-quantity-available-${this.dataset.section} > span`);
      this.price = qs(`#js-main-product-price-${this.dataset.section}`);
      this.shortDescription = qs(`#js-main-product__short-description-${this.dataset.section}`);
      this.promo = qs(`#js-main-product__promo-item-${this.dataset.section}`);
      this.originalPrice = qs(`.js-main-product__price`);
      this.pictograms = qs(`#js-main-product__pictograms-list-${this.dataset.section}`);
      this.productInfo = qs(`#js-product-information-${this.dataset.section}`);
      this.productInfoScript = qs(`#js-product-information-script-${this.dataset.section}`);
      this.variantList = qs(`#js-product-variants-${this.dataset.section}`);
      this.quantityPrice = qs(`.js-main-product__total-price`);
      this.badge = qs(`#js-main-product-badge-sale-${this.dataset.section}`);
      this.mediaIdEl = qs('#js-main-product-current-media-id');
      this.quantity = qs('.js-product-quantity-selector');
      this.inputQuantity = qs('input.product-quantity__input').value;
      this.selectedClass = 'product-variants__select-item--selected';
      this.quantityDisabledClass = 'product-quantity__selector--disabled';
      this.eventClick = false;
      this.open = true;

      this.init();
      this.addEventListener('change', this.onVariantChange);
    }

    init() {
      document.addEventListener('click', () => {
        this.variants.forEach(item => {
          const listWrap = qs('.js-product-variants-select-list-wrap', item);
          const maxHeight = listWrap.style.maxHeight.replace('px', '');
          if(Number(maxHeight) > 0) {
            listWrap.style.maxHeight = 0;
            this.open = true;
          }
        });
      });

      let selectedVariant= qs('.js-product-variants__select-item-input[name="Color"][checked], .js-product-variants__select-item-input[name="Couleur"][checked]');
      if (selectedVariant) {        
        let selectedVariantElement = {};
        selectedVariantElement.target = selectedVariant;
        this.updateVariantList(selectedVariantElement);
      }

      let totalStocks = Number(this.stocks.innerHTML);
      if(totalStocks === 0) {
        this.submitButton.disabled = true;
        this.quantity.classList.add(this.quantityDisabledClass);
      }
    }
  
    onVariantChange(event) {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        this.updateVariantList(event);
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo(event);
        this.updateShareUrl();
      }
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll(`#js-product-variants-${this.dataset.section} .js-product-variants-select-list`));

      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((select) => select.checked).value;
      });

      this.variants.forEach(item => {
        const label = qs('.js-product-variants-dropdown-label', item);
        const current = qs('.js-product-variants-dropdown-current', item);
        const selectItems = qsa('.js-product-variants-select-item', item);

        selectItems.forEach(el => {
          el.classList.remove(this.selectedClass);
        })
        qsa('input', item).forEach(select => {
          if(this.options.indexOf(select.value) > -1) {
            if(label) {
              label.style.display = 'none';
              current.innerText = select.value;
            }
            getClosest('.js-product-variants-select-item', select).classList.add(this.selectedClass);
          } 
        });
      });
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateVariantList(event) {      
      const selectItemClass = 'js-product-variants-select-item';
      const variantSelects = qsa(`.${selectItemClass}`);
      const selectItemHiddenClass = 'product-variants__select-item--hidden';
      const selectItemParentActiveClass = this.selectedClass;
      const selectVariantGroup = qsa('.js-product-variants-select-list');

      if (selectVariantGroup && selectVariantGroup.length > 1) {
        if (!this.eventClick) {
          // hide all variant options except with name same from event target 
          variantSelects.forEach((el) => {
            let varientSelectInput = qs(`.js-product-variants__select-item-input`, el);
            if (varientSelectInput && varientSelectInput.name != 'Color' && varientSelectInput.name != 'Couleur') {
              el.classList.add(selectItemHiddenClass);
            }
          });
    
          const backInForm = qs('.restock-alerts-form');
          if(backInForm) {
            const addButtonWrap = qs('.main-product__checkout-buttons');
            const backMainForm = qs('.main-product__checkout-buttons .restock-alerts-form');
            if(backMainForm) {
              addButtonWrap && addButtonWrap.insertAdjacentElement('afterEnd', backMainForm);
            }
          }
          // show variant options with event variant option value
          this.getVariantData().forEach((variant) => {
            if ((event.target.name == 'Color' || event.target.name == 'Couleur') && variant.options.length > 0 && variant.options.includes(event.target.value)) {
              variant.options.forEach((option) => {
                let variantSelect = qs(`.js-product-variants__select-item-input[value="${option}"]`);
    
                if (variantSelect && variantSelect.parentElement.classList.contains(selectItemClass)) {
                  variantSelect.parentElement.classList.remove(selectItemHiddenClass);
                }
              });
            } else {
              qsa('.js-product-variants__select-item-input[checked]').forEach((checkEl) => {
                if (variant.options.length > 0 && variant.options.includes(checkEl.value)) {
                  variant.options.forEach((option) => {
                    let variantSelect = qs(`.js-product-variants__select-item-input[value="${option}"]`);
        
                    if (variantSelect && variantSelect.parentElement.classList.contains(selectItemClass)) {
                      variantSelect.parentElement.classList.remove(selectItemHiddenClass);
                    }
                  });
                }
              }); 
            }
          });
    
          // move the hidden checked of non-variant to another variant with the same name that is not hidden
          qsa('.js-product-variants__select-item-input[checked]').forEach((checkEl) => {
            if (checkEl.parentElement.classList.contains('hide-varient-selector-nonprice')) {
              let counter = 1;
              checkEl.parentElement.classList.remove(selectItemParentActiveClass);
              checkEl.removeAttribute('checked');
              qsa(`.js-product-variants__select-item-input[name="${checkEl.name}"]`).forEach((el) => {
                if (el.parentElement.classList.contains('hide-varient-selector-nonprice') || counter != 1) {
                  return;
                }
    
                this.eventClick = true;
                el.click();
                counter++;
              });
            }
          });
        } else {
          this.eventClick = false;
          // hide all variant options
          variantSelects.forEach((el) => {
            let input = qs(`.js-product-variants__select-item-input`, el);
            if (input && input.name != 'Color' && input.name != 'Couleur') {
              el.classList.add(selectItemHiddenClass);
            }
          });
  
          // show variant options with event variant option value and other pre-selected value combination
          this.getVariantData().forEach((variant) => {
            if (variant.options.length > 0 && variant.options.includes(event.target.value)) {
              let variantSelect = qs(`.js-product-variants__select-item-input[value="${event.target.value}"]`);

              if (variantSelect && variantSelect.parentElement.classList.contains(selectItemClass)) {
                variantSelect.parentElement.classList.remove(selectItemHiddenClass);
              }
            }

            qsa('.js-product-variants__select-item-input[checked]').forEach((checkEl) => {
              if (checkEl.value != event.target.value & variant.options.includes(checkEl.value)) {
                variant.options.forEach((option) => {
                  let variantSelect = qs(`.js-product-variants__select-item-input[value="${option}"]`);
      
                  if (variantSelect && variantSelect.parentElement.classList.contains(selectItemClass)) {
                    variantSelect.parentElement.classList.remove(selectItemHiddenClass);
                  }
                });
              }
            });
          });
        }
      } 
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButtons = qsa(`#js-social-share-item-${this.dataset.section} > a`);
      if (!shareButtons) return;
      shareButtons.forEach(button => {
        let currentUrl = button.dataset.mainPageUrl;
        button.setAttribute('href', `${currentUrl}?variant=${this.currentVariant.id}`);
      })
    }
  
    updateVariantInput() {
      const input = qs('input[name="id"]', this.productForm);
      input.value = this.currentVariant.id;
      if(this.currentVariant.featured_media !== undefined) {
        this.mediaIdEl.value = this.currentVariant.featured_media.id;
        qsa('.variant-main-media').forEach(mainProductPicto => {
          if( mainProductPicto.id === 'picto-' + this.mediaIdEl.value  ) {
            mainProductPicto.style.display = '';
          } else if (mainProductPicto.style.display !== 'none') {
            mainProductPicto.style.display = 'none';
          }
        });
      }
      this.mediaIdEl.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    removeErrorMessage() {
      if (this.productForm) {
        const errorMessage = false

        this.errorMessageWrapper = this.errorMessageWrapper || qs('.js-product-error-message-wrapper', this.productForm);
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || qs('.js-product-error-message', this.productForm);
  
        this.errorMessageWrapper.toggleAttribute('main-product__error-message--hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }

    renderProductInfo(event) {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const sourcePrice = html.querySelector(`#js-main-product-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const sourceProductStocks = html.querySelector(`#js-product-quantity-available-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} > span`);
          const sourceBadge = html.querySelector(`#js-main-product-badge-sale-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const shortDescription = html.querySelector(`#js-main-product__short-description-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const promo = html.querySelector(`#js-main-product__promo-item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const originalPrice = html.querySelector('.js-main-product__price');
          const pictograms = html.querySelector(`#js-main-product__pictograms-list-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const productInfo = html.querySelector(`#js-product-information-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const productInfoScript = html.querySelector(`#js-product-information-script-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const variantList = html.querySelector(`#js-product-variants-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const quantityPrice = html.querySelector(`.js-main-product__total-price`);
          const inputQuantity = qs('input.product-quantity__input').value;

          if (sourceBadge && this.badge) this.badge.innerHTML = sourceBadge.innerHTML;
          if (sourcePrice && this.price) this.price.innerHTML = sourcePrice.innerHTML;
          if (shortDescription && this.shortDescription) this.shortDescription.innerHTML = shortDescription.innerHTML;
          if (promo && this.promo) {
            this.promo.innerHTML = promo.innerHTML;
          } 
          if (originalPrice && this.originalPrice) this.originalPrice.innerHTML = originalPrice.innerHTML;
          if (pictograms && this.pictograms) this.pictograms.innerHTML = pictograms.innerHTML;
          if (productInfo && this.productInfo) this.productInfo.innerHTML = productInfo.innerHTML;
          if (productInfoScript && this.productInfoScript) {
            const newScript = document.createElement('script');
            newScript.id = `js-product-information-script-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`;
            newScript.src = `${productInfoScript.getAttribute('src')}`;
            newScript.type = 'text/javascript';
            this.productInfo.appendChild(newScript);
          } 
          if (variantList && this.variantList) this.variantList.innerHTML = variantList.innerHTML;
          if (quantityPrice && this.quantityPrice) this.quantityPrice.dataset.singlePrice = quantityPrice.dataset.singlePrice;
          // if (quantityPrice && this.quantityPrice) this.quantityPrice.innerHTML = quantityPrice.innerHTML;
          if (quantityPrice && this.quantityPrice) {
            const buttonText = quantityPrice.innerText;

            if (buttonText !== null) {
              const buttonTextReplace = buttonText.replace(',', '.');
              const buttonTextTotal = (parseFloat(buttonTextReplace) * inputQuantity).toFixed(2);
              const buttonTextString = buttonTextTotal.toString();
              const buttonTotalPrice = buttonTextString.replace('.', ',');

              this.quantityPrice.innerHTML = buttonTotalPrice
            }
          }

          if (sourceProductStocks && this.stocks) {
            let totalStocks = Number(sourceProductStocks.innerHTML);
            this.stocks.innerHTML = totalStocks;
            qs('input', this.quantity).max = totalStocks;
            setTimeout(() => {
              if(totalStocks === 0) {
                this.submitButton.disabled = true;
                this.quantity.classList.add(this.quantityDisabledClass);
              } else {
                this.quantity.classList.remove(this.quantityDisabledClass);
              }
            }, 100);
          }

          if (this.price) this.price.classList.remove('main-product__price--hidden');
          // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.addToCart);

          this.updateVariantList(event);
        });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      if (!this.productForm) return;
      const submitButtonText = qs('span', this.submitButton);
      if (!this.submitButton) return;
  
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        // if (text) submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        // submitButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }

    setUnavailable() {
      if (!this.submitButton) return;
      // submitButtonText.textContent = window.variantStrings.unavailable;
      if (this.price) this.price.classList.add('main-product__price--hidden');
      if(this.price.classList.contains('main-product__price--hidden')){
        qs('.product-variants__select-item--selected').classList.add('hide-varient-selector-nonprice');
      }
      else
      {
        qs('.product-variants__select-item--selected').classList.remove('hide-varient-selector-nonprice');
      }
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define('variant-selects', VariantSelects);
})();